/**
 * Per-page hydration entry for /contact.
 */
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Contact } from '@/pages/Contact.tsx';
import '@/styles/global.css';

const container = document.getElementById('root');
if (container) {
  hydrateRoot(
    container,
    <StrictMode>
      <Contact />
    </StrictMode>,
  );
}
